module.exports = __webpack_public_path__ + "static/image 112-7fb02b7205c1de62cdf49513607d206a.jpg";